<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card outlined flat v-if="org">
                    <v-card-text>
                        Want to create a user? First search if it exists..
                        <v-form v-model="valid" lazy-validate>
                            <v-text-field outlined v-model="string" :rules="[rules.emailRules]" clearable @click:clear="resetApp()" />
                        </v-form>
                        <div v-if="error" class="red--text">{{error.message}}</div>
                        <v-card-actions>
                            <v-btn :disabled="!valid" v-if="!activeuser" :loading="loading" text @click="searchByString()">Search <v-icon>{{icons.search}}</v-icon></v-btn>
                            <v-btn v-else text @click="string=undefined,activeuser=undefined">Clear <v-icon>{{icons.close}}</v-icon></v-btn>
                            <v-btn text v-if="error && error.code==='UserNotFoundException'" @click="createUser()">Create this User</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
                <v-card flat v-if="activeuser">
                    <v-card-title>
                        Enabled: {{activeuser.user.Enabled}}
                    </v-card-title>
                    <v-card-text>
                        <v-list>
                            <v-list-item  v-for="u in activeuser.user.UserAttributes" :key="u.Value">
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize">{{u.Name}}</v-list-item-title>
                                    <v-list-item-subtitle>{{u.Value}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" v-if="activeuser" :fullscreen="$vuetify.breakpoint.xs" max-width="400" scrollable>
            <v-card>
                <v-card-title>
                    Enabled: {{activeuser.user.Enabled}}
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item  v-for="u in activeuser.user.UserAttributes" :key="u.Value">
                            <v-list-item-content>
                                <v-list-item-title class="text-capitalize">{{u.Name}}</v-list-item-title>
                                <v-list-item-subtitle>{{u.Value}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-capitalize">Status {{activeuser.user.UserStatus}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-list-item color="awesome">
                        <v-list-item-content class="info--text">
                            Password rest will override existing password. User/Customer will need to retrieve
                            generated password from email within 24hours, and log in.
                        </v-list-item-content>
                    </v-list-item>
                    <v-list>
                        <v-list-item @click="justSendMeOne()" >
                            <v-list-item-content>
                                <v-list-item-title class="text-capitalize">Reset Password</v-list-item-title>
                                <v-list-item-subtitle>Reset</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action :loading="true">
                                <v-btn icon :loading="sendingreset">
                                    <v-icon>mdi-form-textbox-password</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                        <v-list-item v-if="message">
                            <v-list-item-content class="info--text">
                                {{message.text}}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="activeuser=false,dialog=false,message=undefined,string=undefined">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex';

  export default {
    components: {},
    name: "SearchUsers",
    data() {
      return {
        valid: true,
        string: undefined,
        results: [],
        activeuser: undefined,
        loading: false,
        error: undefined,
        dialog: false,
        sendingreset:false,
        message: undefined
      }
    },
    computed:{
      ...mapState(['org', 'icons', 'rules'])
    },
    mounted() {

    },
    methods: {
      ...mapActions(['get','post']),
      async searchByString(){
        this.loading = true
        let data = await this.post({path:'api/users/searchbystring',body:{string: this.string}})
        this.loading = false
        if(data.error){
          this.error = data.error
        } else {
          this.activeuser = data;
          this.dialog = true;
        }
      },
      async createUser(){
        this.loading = true
        let data = await this.post({path:'api/users/admincreateuser',body:{string: this.string}})
        this.loading = false
        if(data.error){
          this.error = data.error
        } else {
          this.activeuser = data;
          this.dialog = true;
          this.loading = false;
          this.error = undefined;
          this.string = undefined
        }
      },
      resetApp(){
        this.results = []
        this.activeuser = undefined;
        this.loading = false;
        this.error = undefined;
        this.message = undefined;
      },
      async justSendMeOne(){
        let body = {}
        this.activeuser.user.UserAttributes.forEach(f=>{
          body[f.Name]=f.Value
        })
        body.username = this.activeuser.user.Username
        this.sendingreset = true
        let res = await this.post({path:'api/auth/adminsendmeapassword',body:body})
        this.sendingreset = false
        this.message = res.message
      },
    }
  }
</script>

<style scoped>

</style>